import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Card, Loading } from "../components/UI";
import { formatDateTime } from "../lib/format";
import { ShieldCheck } from "lucide-react";

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/audit-logs").then(r => setLogs(r.data)).finally(() => setLoading(false)); }, []);

  if (loading) return <Loading/>;

  return (
    <div className="space-y-6">
      <div className="fade-up">
        <h1 className="font-serif text-3xl font-bold text-[#1A2E24]">Audit Logs</h1>
        <p className="text-[#5E7166] text-sm">{logs.length} actions logged.</p>
      </div>

      <Card className="!p-0 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="modav-table">
            <thead><tr><th>When</th><th>Action</th><th>Module</th><th>Record</th><th>User</th><th>IP</th></tr></thead>
            <tbody>
              {logs.map(l => (
                <tr key={l.id}>
                  <td className="text-xs">{formatDateTime(l.created_at)}</td>
                  <td><span className="badge badge-blue">{l.action}</span></td>
                  <td className="text-xs uppercase tracking-wider">{l.module}</td>
                  <td className="text-xs font-mono">{l.record_id?.slice(0,12) || "—"}</td>
                  <td className="text-xs font-mono">{l.user_id?.slice(0,12) || "—"}</td>
                  <td className="text-xs">{l.ip_address || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
